module.exports = __webpack_public_path__ + "img/xaas-scale.3bbf28d.png";